import React from 'react';

import { components, IndicatorProps, OptionTypeBase } from 'react-select';

type IndicatorSeparatorProps<
  T extends OptionTypeBase,
  U extends boolean,
> = React.PropsWithChildren<IndicatorProps<T, U>> & {
  isClearable?: boolean;
};

function IndicatorSeparator<T extends OptionTypeBase, U extends boolean>({
  hasValue,
  isClearable,
  isDisabled,
  ...props
}: IndicatorSeparatorProps<T, U>): JSX.Element | null {
  if (hasValue && isClearable && !isDisabled) {
    return (
      <components.IndicatorSeparator
        hasValue={hasValue}
        isDisabled={isDisabled}
        {...props}
      />
    );
  }
  return null;
}

export default IndicatorSeparator;
